import { OperationInterface } from '../data';

export abstract class OperationFactoryInterface {
    abstract build(): OperationInterface;
}
